import {
  useDefaultTipAmount,
  useIsTipEnabled
} from 'reservations/account/providers/ConfigProvider';
import { useDefaultPartySize } from 'reservations/booking/hooks/useDefaultPartySize';
import { RESERVATION } from 'reservations/booking/types';
import { BookingFormSchema } from 'reservations/form/components/Form';

export const useDefaultBookingFormValues = (
  defaultFormValues?: BookingFormSchema
) => {
  const partySize = useDefaultPartySize();
  const defaultTip = useDefaultTipAmount();
  const isTipEnabled = useIsTipEnabled();

  return {
    partySize: defaultFormValues?.partySize ?? partySize,
    date: defaultFormValues?.date ?? new Date(),
    name: defaultFormValues?.name ?? '',
    email: defaultFormValues?.email ?? '',
    specialOccasion: defaultFormValues?.specialOccasion ?? 'None',
    note: defaultFormValues?.note ?? '',
    phone: defaultFormValues?.phone ?? '',
    phoneCode: defaultFormValues?.phoneCode ?? '',
    fullPhoneNumber: defaultFormValues?.fullPhoneNumber ?? '',
    optInMarketingEmail: defaultFormValues?.optInMarketingEmail ?? true,
    optInMarketingSms: defaultFormValues?.optInMarketingSms ?? false,
    time: defaultFormValues?.time ?? -1,
    availability: defaultFormValues?.availability ?? null,
    bookingType: defaultFormValues?.bookingType ?? RESERVATION,
    token: '',
    cardDetails: null,
    savedPaymentMethod: defaultFormValues?.savedPaymentMethod ?? '',
    optInChecklessPayments: defaultFormValues?.optInChecklessPayments ?? false,
    tipPercentage: isTipEnabled
      ? defaultFormValues?.tipPercentage ?? defaultTip
      : 0,
    guests: defaultFormValues?.guests ?? []
  };
};
